import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LanguageUtil } from '../../shared/util/language-util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModalComponent } from '../../shared/modals/loading-modal/loading-modal.component';
import { SimpleModalComponent } from '../../shared/modals/simple-modal/simple-modal.component';

@Injectable()
export class ServiceInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];

    constructor(
        private translate: TranslateService,
        private modalService: NgbModal
    ) {
    }

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modalLoading = this.modalService.open(LoadingModalComponent, { windowClass: 'xlModal', centered: true, backdrop: 'static' });

        request = request.clone(
            {
                headers: request.headers.set('Accept-Language', LanguageUtil.retornaAcceptLanguage(this.translate.currentLang))
            }
        );

        this.requests.push(request);

        return new Observable(observable => {
            const subscription = next.handle(request)
                .subscribe(
                    res => {
                        if (res instanceof HttpResponse) {
                            modalLoading.dismiss();
                            this.removeRequest(request);
                            observable.next(res);
                        }
                    },
                    err => {
                        modalLoading.dismiss();
                        this.removeRequest(request);
                        if (err.status != null && err.status !== 0) {
                            observable.error(err);
                        } else {
                            const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                            modalRef.componentInstance.message = this.carregarMensagemErro();
                        }
                    },
                    () => {
                        modalLoading.dismiss();
                        this.removeRequest(request);
                        observable.complete();
                    });
            return () => {
                modalLoading.dismiss();
                this.removeRequest(request);
                subscription.unsubscribe();
            };
        });
    }

    carregarMensagemErro() {
        const language = this.translate.currentLang;
        if (language === 'pt') {
            return 'Erro no processamento!';
        } else if (language === 'es') {
            return 'Error de procesamiento';
        } else if (language === 'en') {
            return 'Processing Error!';
        } else {
            return 'Processing Error!';
        }
    }

}
